import React from 'react';
import styled from 'styled-components';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import palette from '../../lib/styles/palette';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const RadioBox = styled.div`
    display: flex;
    align-items: center;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 20px;
    padding: 4px 16px;

    .MuiFormControlLabel-label {
        font-size: 0.95rem;
        color: #2c3e50;
    }

    .MuiRadio-colorPrimary.Mui-checked {
        color: ${palette.webCyan[5]};
    }
`;

const AdminClubStatusInfo = ({
    selectClubInfo,
    setStatus,
    setChangeStatusInfo
}) => {

    const onChangeStatusFlag = (e)=>{
        setStatus(parseInt(e.target.value))
    }

  return selectClubInfo ? (
    <SettingCard title="클럽 활성화 설정">
        <SettingInfoBox>
            <SettingInfoLabel>활성화 유무</SettingInfoLabel>
            <SettingInfoValue>
                <RadioBox>
                    <RadioGroup
                        aria-label="type"
                        name="viewType"
                        value={selectClubInfo.clubStatus}
                        onChange={onChangeStatusFlag}
                        row={true}
                    >
                        <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="활성화"
                        />
                        <FormControlLabel
                            value={2}
                            control={<Radio color="primary" />}
                            label="비활성화"
                        />
                    </RadioGroup>
                </RadioBox>
            </SettingInfoValue>
        </SettingInfoBox>
        <CardFooter>
            <SaveButton active={selectClubInfo.isStatusEdit} onClick={() => setChangeStatusInfo()}>
                수정하기
            </SaveButton>
        </CardFooter>
    </SettingCard>
  ) : null;
};

export default React.memo(AdminClubStatusInfo);
